import React, { useEffect } from "react";
import { useCheckoutContext } from "../../context/CheckoutContext";
import {
  useCheckoutSubscriptionStatus,
  usePromotionalCampaign,
} from "../../hooks";
import {
  CheckoutHeader,
  CheckoutFooter,
  StepperCustom,
  CheckoutPlansVindi,
  CheckoutPlansBestFriday,
} from "../../components";

import * as S from "./styles";

const CheckoutPlans = () => {
  const { currentStep, checkoutSteps, changeStep } = useCheckoutContext();
  const { data: campaign } = usePromotionalCampaign();

  useEffect(() => {
    changeStep("entenda");
  }, []);

  useCheckoutSubscriptionStatus();

  return (
    <S.Wrapper>
      <CheckoutHeader />
      <StepperCustom steps={checkoutSteps} currentStep={currentStep} />
      {/* BEST FRIDAY */}
      {!!campaign ? <CheckoutPlansBestFriday /> : <CheckoutPlansVindi />}
      <CheckoutFooter />
    </S.Wrapper>
  );
};

export default CheckoutPlans;
